/* eslint-disable */
import React from "react";
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton, TelegramShareButton, PinterestShareButton, RedditShareButton, EmailShareButton, FacebookIcon, LinkedinIcon, WhatsappIcon, TelegramIcon, PinterestIcon, RedditIcon, EmailIcon } from "react-share";
import axios from "axios";
import { FB_URL } from "../../store/actions/types";
import { app_config } from "../../constants";
import UploadFiles from "../UploadFiles/index.js";

const shareStyle = {
  marginLeft: "auto",
  marginTop: "auto",
  minWidth: "240px",
  maxWidth: "480px",
  width: "100%",
  padding: "16px",
  background: "#fff",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
  boxSizing: "border-box",
  overflowX: "hidden",
};

const imageContainerStyle = {
  maxHeight: "300px", // Reduced for mobile compatibility
  overflowY: "auto",
  marginBottom: "15px", // Reduced margin
};

const imageTableStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "10px",
};

const imageStyle = {
  width: "150px",
  height: "100px",
  objectFit: "cover",
  cursor: "pointer",
  border: "2px solid transparent",
};

const backArrowStyle = {
  width: "48px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#007bff",
  color: "#fff",
  borderRadius: "50%",
  cursor: "pointer",
  fontSize: "28px",
  fontWeight: "900",
  textDecoration: "none",
  border: "none",
  outline: "none",
  lineHeight: 1,
};

const XIconCircle = ({ size = 48 }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: "#000",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 800,
      fontSize: Math.round(size * 0.5),
      lineHeight: 1,
    }}
    aria-label="Share on X"
  >
    X
  </div>
);

const copyButtonStyle = {
  background: "#1976d2",
  color: "#fff",
  border: "none",
  borderRadius: "18px",
  padding: "6px 12px",
  fontSize: "12px",
  fontWeight: 600,
  cursor: "pointer",
  boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
};

const copyButtonHoverStyle = {
  ...copyButtonStyle,
  background: "#1565c0",
};

class Sharebuttons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previewUrl: "",
      error: null,
      selectedImage: null,
      isUploading: false,
      copied: false,
      copyHover: false,
      isPreparingPreview: false,
      fbLiPreviewUrl: "", // OG preview URL (for Facebook/LinkedIn only)
      imageUrls: [
        "https://media.cnn.com/api/v1/images/stellar/prod/171215104434-world-leaders-review-piece-teaser.jpg",
        "https://localiq.com/wp-content/uploads/2021/06/IS-stock-hero.jpg",
        "https://miro.medium.com/v2/resize:fit:711/1*QF9I9UNvBqE3JCSsbq1pMg.png",
        "https://www.psychologicalscience.org/redesign/wp-content/uploads/2015/12/PAFF_040118_helpingothers-1024x576.jpg",
        "https://thinkleadecosystem.com/wp-content/uploads/2021/04/WEBSITE-Image-5-768x513.jpeg",
        "https://thinkleadecosystem.com/wp-content/uploads/2021/04/WEBSITE-Image-6-1-768x512.jpeg",
        "https://static.toiimg.com/thumb/msid-100099646,imgsize-46676,width-400,resizemode-4/100099646.jpg",
      ],
    };
  }

  getCanonicalPostUrl = () => {
    const raw = this.props.post || '';
    const prodBase = (app_config && app_config.serverURL ? app_config.serverURL : '').replace(/\/$/, '');
    if (!raw) return prodBase || window.location.origin;
    // Replace localhost with public base if available
    const normalized = raw.replace(/^http:\/\/localhost:\d+/, prodBase || window.location.origin);
    return normalized;
  };

  getPreviewFnBase = () => {
    try {
      if (app_config && app_config.graphQLURL) {
        const origin = new URL(app_config.graphQLURL).origin; // e.g. https://us-central1-leadershipplatform-158316.cloudfunctions.net
        return origin;
      }
    } catch (e) {}
    return (FB_URL || '').replace(/\/$/, '');
  };

  generateTeaser = (rawText, maxChars = 180) => {
    try {
      if (!rawText) return '';
      let text = String(rawText).replace(/\s+/g, ' ').trim();
      if (text.length <= maxChars) return text;
      const slice = text.slice(0, maxChars);
      const lastSpace = slice.lastIndexOf(' ');
      const trimmed = lastSpace > 50 ? slice.slice(0, lastSpace) : slice;
      return `${trimmed.trim()}…`;
    } catch (e) {
      return '';
    }
  };

  

  handleImageSelect = async (imageUrl) => {
    // Always share the direct post link for most platforms
    // Also request an OG preview URL from the existing Cloud Function for Facebook/LinkedIn
    const directPost = this.getCanonicalPostUrl();
    this.setState({ selectedImage: imageUrl, previewUrl: directPost, fbLiPreviewUrl: "", isPreparingPreview: true });

    try {
      if (!this.props.thought || !this.props.post) return;

      const base = this.getPreviewFnBase();
      const res = await axios.post(
        `${base}/m112`,
        {
          params: {
            postTitle: this.props.thought,
            postreturn: directPost,
            postDescription: "Me Vision thought",
            imageUrl: imageUrl,
          },
        },
        { timeout: 10000 }
      );

      if (res && res.data && res.data.previewUrl) {
        this.setState({ fbLiPreviewUrl: res.data.previewUrl });
      }
    } catch (error) {
      // Non-fatal for FB/LinkedIn; they will fall back to direct URL without preview
    }
    finally {
      this.setState({ isPreparingPreview: false });
    }
  };

  tryWebShareWithImage = async (shareUrl) => {
    try {
      if (!this.state.selectedImage) return false;
      if (!navigator.share) return false;
      // Pre-copy link so user can paste if the target app drops caption
      try { await navigator.clipboard.writeText(shareUrl); } catch (e) {}
      const res = await fetch(this.state.selectedImage, { mode: 'cors' });
      if (!res.ok) return false;
      const blob = await res.blob();
      const ext = blob.type === 'image/png' ? 'png' : 'jpg';
      const file = new File([blob], `thinklead-share.${ext}`, { type: blob.type || 'image/jpeg' });
      if (navigator.canShare && !navigator.canShare({ files: [file] })) return false;
      const caption = this.props.thought ? `${this.props.thought}\n\n${shareUrl}` : shareUrl;
      // Try with url + text + files
      try {
        await navigator.share({ files: [file], text: caption, url: shareUrl, title: this.props.thought || 'ThinkLead' });
        return true;
      } catch (errWithUrl) {
        // Retry without url if the platform disallows url + files together
        try {
          await navigator.share({ files: [file], text: caption, title: this.props.thought || 'ThinkLead' });
          return true;
        } catch (errNoUrl) {
          return false;
        }
      }
    } catch (e) {
      return false;
    }
  };

  downloadSelectedImage = async () => {
    try {
      if (!this.state.selectedImage) return false;
      const resp = await fetch(this.state.selectedImage, { mode: 'cors' });
      if (!resp.ok) return false;
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'thinklead-share.jpg';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  handleWhatsAppShare = async () => {
    try {
      await this.ensurePreviewReady();
    } catch (e) {}
    const directPost = this.getCanonicalPostUrl();
    const shareUrl = this.state.fbLiPreviewUrl || this.state.previewUrl || directPost;
    // Send caption (title + link) in the WhatsApp text for both mobile and desktop
    const teaser = this.generateTeaser(this.props.thought || '', 200);
    const text = teaser ? `${teaser}\n${shareUrl}` : `${shareUrl}`;
    const appUrl = `whatsapp://send?text=${encodeURIComponent(text)}`;
    const webUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;

    const cancelers = { t: null };
    const cancelFallback = () => {
      if (cancelers.t) {
        clearTimeout(cancelers.t);
        cancelers.t = null;
      }
      window.removeEventListener('blur', cancelFallback);
      document.removeEventListener('visibilitychange', visibilityHandler);
    };
    const visibilityHandler = () => {
      if (document.hidden) cancelFallback();
    };
    window.addEventListener('blur', cancelFallback);
    document.addEventListener('visibilitychange', visibilityHandler);

    cancelers.t = setTimeout(() => {
      window.open(webUrl, '_blank', 'noopener');
      cancelFallback();
    }, 1000);
    try {
      window.location.href = appUrl;
    } catch (e) {
      if (cancelers.t) {
        clearTimeout(cancelers.t);
        cancelers.t = null;
      }
      window.open(webUrl, '_blank', 'noopener');
      cancelFallback();
    }
  };

  handleWhatsAppImageCaption = async () => {
    try { await this.ensurePreviewReady(); } catch (e) {}
    const directPost = this.getCanonicalPostUrl();
    const shareUrl = this.state.fbLiPreviewUrl || this.state.previewUrl || directPost;
    const caption = this.props.thought ? `${this.props.thought}\n\n${shareUrl}` : shareUrl;
    try { await navigator.clipboard.writeText(caption); } catch (e) {}
    await this.downloadSelectedImage();
    const waUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(caption)}`;
    window.open(waUrl, '_blank', 'noopener');
  };

  ensurePreviewReady = async () => {
    if (this.state.fbLiPreviewUrl || !this.props.thought || !this.props.post) {
      return;
    }
    // If a preview is not ready yet, try to create it using the last selected image
    if (!this.state.selectedImage) return;
    try {
      this.setState({ isPreparingPreview: true });
      const base = this.getPreviewFnBase();
      const res = await axios.post(
        `${base}/m112`,
        {
          params: {
            postTitle: this.props.thought,
            postreturn: this.getCanonicalPostUrl(),
            postDescription: "Me Vision thought",
            imageUrl: this.state.selectedImage,
          },
        },
        { timeout: 10000 }
      );
      if (res && res.data && res.data.previewUrl) {
        this.setState({ fbLiPreviewUrl: res.data.previewUrl });
      }
    } catch (e) {
      // ignore; share will proceed with direct link
    } finally {
      this.setState({ isPreparingPreview: false });
    }
  };

  onImageUploadFinished = (url) => {
    if (url) {
      this.handleImageSelect(url);
    }
    this.setState({ isUploading: false });
  };

  uploadInProgress = (status) => {
    this.setState({ isUploading: status });
  };

  handleGoBack = () => {
    this.setState({
      previewUrl: "",
      selectedImage: null,
      error: null,
    });
  };

  copyShareLink = async () => {
    try {
      const linkToCopy = this.props.post || this.state.previewUrl || "";
      await navigator.clipboard.writeText(linkToCopy);
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 1500);
    } catch (e) {
      this.setState({ error: "Unable to copy link. Please copy manually." });
    }
  };

  

  render() {
    const { previewUrl, error, imageUrls, selectedImage, isUploading, copied, isPreparingPreview } = this.state;

    if (error) {
      return (
        <div style={shareStyle}>
          <div>Error: {error}</div>
        </div>
      );
    }

    return (
      <div style={shareStyle}>
        {!previewUrl && !selectedImage ? (
          <div>
            <h3>Select an Image</h3>
            
            <div style={{ marginBottom: "12px" }}>
              <UploadFiles
                uploadtype="image"
                onUploadComplete={this.onImageUploadFinished}
                onUploadProgress={this.uploadInProgress}
              />
              {isUploading ? <div style={{ fontSize: 12, color: "#666" }}>Uploading...</div> : null}
            </div>
            <div style={imageContainerStyle}>
              <div style={imageTableStyle}>
                {imageUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Image ${index + 1}`}
                    style={imageStyle}
                    onClick={() => this.handleImageSelect(url)}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}>
              <TwitterShareButton url={this.state.fbLiPreviewUrl || previewUrl} title="Check out this thought!" beforeOnClick={this.ensurePreviewReady}>
                <XIconCircle size={48} />
              </TwitterShareButton>
              <FacebookShareButton url={this.state.fbLiPreviewUrl || previewUrl} quote="Me Vision thought" beforeOnClick={this.ensurePreviewReady}>
                <FacebookIcon size={48} round />
              </FacebookShareButton>
              <LinkedinShareButton url={this.state.fbLiPreviewUrl || previewUrl} title="Me Vision thought" beforeOnClick={this.ensurePreviewReady}>
                <LinkedinIcon size={48} round />
              </LinkedinShareButton>
              <div onClick={this.handleWhatsAppShare} title="Share on WhatsApp" style={{ cursor: "pointer" }}>
                <WhatsappIcon size={48} round />
              </div>
              <TelegramShareButton
                url={this.state.fbLiPreviewUrl || previewUrl}
                title={this.generateTeaser(this.props.thought || '', 200)}
                beforeOnClick={this.ensurePreviewReady}
              >
                <TelegramIcon size={48} round />
              </TelegramShareButton>
              <PinterestShareButton
                url={this.state.fbLiPreviewUrl || previewUrl}
                media={selectedImage || imageUrls[0]}
                description={this.generateTeaser(this.props.thought || '', 200)}
                beforeOnClick={this.ensurePreviewReady}
              >
                <PinterestIcon size={48} round />
              </PinterestShareButton>
              <RedditShareButton
                url={this.state.fbLiPreviewUrl || previewUrl}
                title={this.generateTeaser(this.props.thought || '', 200)}
                beforeOnClick={this.ensurePreviewReady}
              >
                <RedditIcon size={48} round />
              </RedditShareButton>
              <EmailShareButton url={previewUrl} subject="Me Vision thought">
                <EmailIcon size={48} round />
              </EmailShareButton>
              <button style={backArrowStyle} onClick={this.handleGoBack} title="Go back to images">
                ←
              </button>
            </div>
            <div style={{ marginTop: "12px", display: "grid", gap: "8px" }}>
              <div style={{ fontSize: 12, color: "#444", textAlign: "center", overflowWrap: "anywhere", wordBreak: "break-word", whiteSpace: "normal", padding: "0 8px" }}>
                Instagram & TikTok do not support direct URL shares. Copy the link and add it to your bio or use a Story link sticker.
              </div>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
                <button
                  style={this.state.copyHover ? copyButtonHoverStyle : copyButtonStyle}
                  onMouseOver={() => this.setState({ copyHover: true })}
                  onMouseLeave={() => this.setState({ copyHover: false })}
                  onClick={this.copyShareLink}
                  disabled={copied}
                >
                  {copied ? "Copied!" : "Copy Share Link"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Sharebuttons;
//////////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
//   maxWidth: "340px", // Constrain modal width for 2-column grid
//   maxHeight: "80vh", // Limit modal height to 80% of viewport height
//   padding: "20px",
//   background: "#fff",
//   borderRadius: "8px",
//   boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//   overflowY: "auto", // Allow modal to scroll if content overflows
//   boxSizing: "border-box",
// };

// const imageContainerStyle = {
//   maxHeight: "400px", // Fixed height for image grid
//   overflowY: "auto", // Enable vertical scrolling
//   marginBottom: "20px",
// };

// const imageTableStyle = {
//   display: "grid",
//   gridTemplateColumns: "repeat(2, 1fr)",
//   gap: "10px",
// };

// const imageStyle = {
//   width: "150px",
//   height: "100px",
//   objectFit: "cover",
//   cursor: "pointer",
//   border: "2px solid transparent",
// };

// const backArrowStyle = {
//   width: "48px",
//   height: "48px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   background: "#007bff",
//   color: "#fff",
//   borderRadius: "50%",
//   cursor: "pointer",
//   fontSize: "28px", // Adjusted back to previous working size
//   fontWeight: "900",
//   textDecoration: "none",
//   border: "none",
//   outline: "none",
//   lineHeight: 1,
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//       selectedImage: null,
//       imageUrls: [
//         "https://media.cnn.com/api/v1/images/stellar/prod/171215104434-world-leaders-review-piece-teaser.jpg",
//         "https://localiq.com/wp-content/uploads/2021/06/IS-stock-hero.jpg",
//         "https://miro.medium.com/v2/resize:fit:711/1*QF9I9UNvBqE3JCSsbq1pMg.png",
//         "https://www.psychologicalscience.org/redesign/wp-content/uploads/2015/12/PAFF_040118_helpingothers-1024x576.jpg",
//         "https://thinkleadecosystem.com/wp-content/uploads/2021/04/WEBSITE-Image-5-768x513.jpeg",
//         "https://thinkleadecosystem.com/wp-content/uploads/2021/04/WEBSITE-Image-6-1-768x512.jpeg",
//         "https://static.toiimg.com/thumb/msid-100099646,imgsize-46676,width-400,resizemode-4/100099646.jpg",
//       ],
//     };
//   }

//   handleImageSelect = async (imageUrl) => {
//     this.setState({ selectedImage: imageUrl });

//     try {
//       if (!this.props.thought || !this.props.post) {
//         throw new Error("Missing required props");
//       }

//       const res = await axios.post(
//         `${FB_URL}/m112`,
//         {
//           params: {
//             postTitle: this.props.thought,
//             postreturn: this.props.post,
//             postDescription: "Me Vision thought",
//             imageUrl: imageUrl,
//           },
//         },
//         {
//           timeout: 10000,
//         }
//       );

//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//         request: error.request,
//       });
//       this.setState({ error: error.response?.data?.message || error.message });
//     }
//   };

//   handleGoBack = () => {
//     // Reset state to show image selection again
//     this.setState({
//       previewUrl: "",
//       selectedImage: null,
//       error: null,
//     });
//   };

//   render() {
//     const { previewUrl, error, imageUrls, selectedImage } = this.state;

//     if (error) {
//       return (
//         <div style={shareStyle}>
//           <div>Error: {error}</div>
//         </div>
//       );
//     }

//     return (
//       <div style={shareStyle}>
//         {!previewUrl && !selectedImage ? (
//           <div>
//             <h3>Select an Image</h3>
//             <div style={imageContainerStyle}>
//               <div style={imageTableStyle}>
//                 {imageUrls.map((url, index) => (
//                   <img
//                     key={index}
//                     src={url}
//                     alt={`Image ${index + 1}`}
//                     style={imageStyle}
//                     onClick={() => this.handleImageSelect(url)}
//                   />
//                 ))}
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div>
//             <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//               <TwitterShareButton url={previewUrl} title="Check out this thought!">
//                 <TwitterIcon size={48} round />
//               </TwitterShareButton>
//               <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//                 <FacebookIcon size={48} round />
//               </FacebookShareButton>
//               <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//                 <LinkedinIcon size={48} round />
//               </LinkedinShareButton>
//               <button style={backArrowStyle} onClick={this.handleGoBack} title="Go back to images">
//                 ←
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;
////////////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
//   padding: "20px",
//   background: "#fff",
//   borderRadius: "8px",
//   boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
// };

// const imageTableStyle = {
//   display: "grid",
//   gridTemplateColumns: "repeat(2, 1fr)",
//   gap: "10px",
//   marginBottom: "20px",
// };

// const imageStyle = {
//   width: "150px",
//   height: "100px",
//   objectFit: "cover",
//   cursor: "pointer",
//   border: "2px solid transparent",
// };

// const backArrowStyle = {
//   width: "48px", // Match social media icon size
//   height: "48px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   background: "#007bff",
//   color: "#fff",
//   borderRadius: "50%",
//   cursor: "pointer",
//   fontSize: "50px", // Slightly larger for bigger arrow
//   fontWeight: "900", // Bolder arrow
//   textDecoration: "none",
//   border: "none",
//   outline: "none",
//   lineHeight: 1, // Normalize line height to aid centering
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//       selectedImage: null,
//       imageUrls: [
//         "https://media.cnn.com/api/v1/images/stellar/prod/171215104434-world-leaders-review-piece-teaser.jpg",
//         "https://localiq.com/wp-content/uploads/2021/06/IS-stock-hero.jpg",
//         "https://miro.medium.com/v2/resize:fit:711/1*QF9I9UNvBqE3JCSsbq1pMg.png",
//         "https://www.psychologicalscience.org/redesign/wp-content/uploads/2015/12/PAFF_040118_helpingothers-1024x576.jpg",
//         "https://thinkleadecosystem.com/wp-content/uploads/2021/04/WEBSITE-Image-5-768x513.jpeg",
//         "https://thinkleadecosystem.com/wp-content/uploads/2021/04/WEBSITE-Image-6-1-768x512.jpeg",
//         "https://static.toiimg.com/thumb/msid-100099646,imgsize-46676,width-400,resizemode-4/100099646.jpg",
//       ],
//     };
//   }

//   handleImageSelect = async (imageUrl) => {
//     this.setState({ selectedImage: imageUrl });

//     try {
//       if (!this.props.thought || !this.props.post) {
//         throw new Error("Missing required props");
//       }

//       const res = await axios.post(
//         `${FB_URL}/m112`,
//         {
//           params: {
//             postTitle: this.props.thought,
//             postreturn: this.props.post,
//             postDescription: "Me Vision thought",
//             imageUrl: imageUrl,
//           },
//         },
//         {
//           timeout: 10000,
//         }
//       );

//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//         request: error.request,
//       });
//       this.setState({ error: error.response?.data?.message || error.message });
//     }
//   };

//   handleGoBack = () => {
//     // Reset state to show image selection again
//     this.setState({
//       previewUrl: "",
//       selectedImage: null,
//       error: null,
//     });
//   };

//   render() {
//     const { previewUrl, error, imageUrls, selectedImage } = this.state;

//     if (error) {
//       return (
//         <div style={shareStyle}>
//           <div>Error: {error}</div>
//         </div>
//       );
//     }

//     return (
//       <div style={shareStyle}>
//         {!previewUrl && !selectedImage ? (
//           <div>
//             <h3>Select an Image</h3>
//             <div style={imageTableStyle}>
//               {imageUrls.map((url, index) => (
//                 <img
//                   key={index}
//                   src={url}
//                   alt={`Image ${index + 1}`}
//                   style={imageStyle}
//                   onClick={() => this.handleImageSelect(url)}
//                 />
//               ))}
//             </div>
//           </div>
//         ) : (
//           <div>
//             <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//               <TwitterShareButton url={previewUrl} title="Check out this thought!">
//                 <TwitterIcon size={48} round />
//               </TwitterShareButton>
//               <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//                 <FacebookIcon size={48} round />
//               </FacebookShareButton>
//               <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//                 <LinkedinIcon size={48} round />
//               </LinkedinShareButton>
//               <button style={backArrowStyle} onClick={this.handleGoBack} title="Go back to images">
//                 ←
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;
//////////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//     };
//   }

//   async componentDidMount() {
//     try {
//       if (!this.props.thought || !this.props.post) {
//         throw new Error("Missing required props");
//       }
//      // const imageRes = await axios.get(`${FB_URL}/m114-generateImage?text=${encodeURIComponent(this.props.thought)}`);

//       const res = await axios.post(`${FB_URL}/m112`, {
//         params: {
//           postTitle: this.props.thought,
//           postreturn: this.props.post,
//           postDescription: "Me Vision thought",
//           // imageUrl: imageRes.data.imageUrl
//           imageUrl: "https://www.psychologicalscience.org/redesign/wp-content/uploads/2015/12/PAFF_040118_helpingothers-1024x576.jpg",
//          // imageUrl: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?fit=crop&w=1200&h=628",
//         },
//       }, {
//         timeout: 10000,
//       });
//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//         request: error.request,
//       });
//       this.setState({ error: error.response?.data?.message || error.message });
//     }
//   }

//   render() {
//     const { previewUrl, error } = this.state;

//     if (error) {
//       return <div>Error: {error}</div>;
//     }

//     return (
//       <div style={shareStyle}>
//       {previewUrl ? (
//         <div style={{ display: 'flex', gap: '10px' }}>
//           <TwitterShareButton url={previewUrl} title="Check out this thought!">
//             <TwitterIcon size={48} round />
//           </TwitterShareButton>
//           <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//             <FacebookIcon size={48} round />
//           </FacebookShareButton>
//           <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//             <LinkedinIcon size={48} round />
//           </LinkedinShareButton>
//         </div>
//       ) : (
//         <div>Loading share buttons...</div>
//       )}
//     </div>
//     );
//   }
// }

// export default Sharebuttons;
/////////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//     };
//   }

//   async componentDidMount() {
//     try {
//       if (!this.props.thought || !this.props.post) {
//         throw new Error("Missing required props");
//       }
//       const res = await axios.post(`${FB_URL}/m112`, {
//         params: {
//           postTitle: this.props.thought,
//           postreturn: this.props.post,
//           postDescription: "Me Vision thought",
//           imageUrl: "https://picsum.photos/1200/628",
//         },
//       });
//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//         request: error.request,
//       });
//       this.setState({ error: error.response?.data?.message || error.message });
//     }
//   }

//   render() {
//     const { previewUrl, error } = this.state;

//     if (error) {
//       return <div>Error: {error}</div>;
//     }

//     return (
//       <div style={shareStyle}>
//         {previewUrl ? (
//           <>
//             <TwitterShareButton url={previewUrl} title="Check out this thought!">
//               <TwitterIcon size={32} round />
//             </TwitterShareButton>
//             <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//               <FacebookIcon size={32} round />
//             </FacebookShareButton>
//             <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//               <LinkedinIcon size={32} round />
//             </LinkedinShareButton>
//           </>
//         ) : (
//           <div>Loading share buttons...</div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;
////////////////////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//     };
//   }

//   async componentDidMount() {
//     try {
//       if (!this.props.thought || !this.props.post) {
//         throw new Error("Missing required props");
//       }
//       const res = await axios.post(`${FB_URL}/m112-sharepreview`, {
//         params: {
//           postTitle: this.props.thought,
//           postreturn: this.props.post,
//           postDescription: "Me Vision thought",
//           imageUrl: "https://picsum.photos/1200/628",
//         },
//       });
//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//       });
//       this.setState({ error: error.message });
//     }
//   }

//   render() {
//     const { previewUrl, error } = this.state;

//     if (error) {
//       return <div>Error: {error}</div>;
//     }

//     return (
//       <div style={shareStyle}>
//         {previewUrl ? (
//           <>
//             <TwitterShareButton url={previewUrl} title="Check out this thought!">
//               <TwitterIcon size={32} round />
//             </TwitterShareButton>
//             <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//               <FacebookIcon size={32} round />
//             </FacebookShareButton>
//             <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//               <LinkedinIcon size={32} round />
//             </LinkedinShareButton>
//           </>
//         ) : (
//           <div>Loading share buttons...</div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;
//////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//     };
//   }

//   async componentDidMount() {
//     try {
//       if (!this.props.thought || !this.props.post) {
//         throw new Error("Missing required props");
//       }
//       const res = await axios.post(`${FB_URL}/m112-sharepreview`, {
//         params: {
//           postTitle: this.props.thought,
//           postreturn: this.props.post,
//           postDescription: "Me Vision thought",
//           imageUrl: "https://ibb.co/B25xnRZv",
//         },
//       });
//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//       });
//       this.setState({ error: error.message });
//     }
//   }

//   render() {
//     const { previewUrl, error } = this.state;

//     if (error) {
//       return <div>Error: {error}</div>;
//     }

//     return (
//       <div style={shareStyle}>
//         {previewUrl ? (
//           <>
//             <TwitterShareButton url={previewUrl} title="Check out this thought!">
//               <TwitterIcon size={32} round />
//             </TwitterShareButton>
//             <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//               <FacebookIcon size={32} round />
//             </FacebookShareButton>
//             <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//               <LinkedinIcon size={32} round />
//             </LinkedinShareButton>
//           </>
//         ) : (
//           <div>Loading share buttons...</div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;
//////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon } from "react-share";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//     };
//   }

//   async componentDidMount() {
//     try {
//       if (!this.props.thought || !this.props.post || !this.props.imageURL) {
//         throw new Error("Missing required props");
//       }
//       const res = await axios.post(`${FB_URL}/m112-sharepreview`, {
//         params: {
//           postTitle: this.props.thought,
//           postreturn: this.props.post,
//           postDescription: "Me Vision thought",
//           imageUrl: 'https://ibb.co/B25xnRZv' //this.props.imageURL,
//         },
//       });
//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//       });
//       this.setState({ error: error.message });
//     }
//   }

//   render() {
//     const { previewUrl, error } = this.state;

//     if (error) {
//       return <div>Error: {error}</div>;
//     }

//     return (
//       <div style={shareStyle}>
//         {previewUrl ? (
//           <>
//             <TwitterShareButton url={previewUrl} title="Check out this thought!">
//               <TwitterIcon size={32} round />
//             </TwitterShareButton>
//             <FacebookShareButton url={previewUrl} quote="Me Vision thought">
//               <FacebookIcon size={32} round />
//             </FacebookShareButton>
//             <LinkedinShareButton url={previewUrl} title="Me Vision thought">
//               <LinkedinIcon size={32} round />
//             </LinkedinShareButton>
//           </>
//         ) : (
//           <div>Loading share buttons...</div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;
//////////////////////////////////////////////////////////////////////////////////////
// /* eslint-disable */
// import React from "react";
// import { Facebook, Twitter, Linkedin } from "react-social-sharing";
// import axios from "axios";
// import { FB_URL } from "../../store/actions/types";

// const shareStyle = {
//   marginLeft: "auto",
//   marginTop: "auto",
//   minWidth: "200px",
// };

// class Sharebuttons extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       previewUrl: "",
//       error: null,
//     };
//   }

//   async componentDidMount() {
//     try {
//       if (!this.props.thought || !this.props.post || !this.props.imageURL) {
//         throw new Error("Missing required props");
//       }
      
//       const res = await axios.post(`${FB_URL}/m112-sharepreview`, {
//         params: {
//           postTitle: this.props.thought,
//           postreturn: this.props.post,
//           postDescription: "Me Vision thought",
//           imageUrl: 'https://ibb.co/B25xnRZv' //this.props.imageURL,
//         },
//       });
//       this.setState({ previewUrl: res.data.previewUrl });
//     } catch (error) {
//         message: error.message,
//         response: error.response?.data,
//         status: error.response?.status,
//       });
//       this.setState({ error: error.message });
//     }
//   }

//   render() {
//     const { previewUrl, error } = this.state;

//     if (error) {
//       return <div>Error: {error}</div>;
//     }

//     return (
//       <div style={shareStyle}>
//         {previewUrl ? (
//           <>
//             <Twitter link={previewUrl} text="Check out this thought!" />
//             <Facebook link={previewUrl} />
//             <Linkedin link={previewUrl} text="Me Vision thought" />
//           </>
//         ) : (
//           <div>Loading share buttons...</div>
//         )}
//       </div>
//     );
//   }
// }

// export default Sharebuttons;

